module.exports = __webpack_public_path__ + "img/39_36.ac6a0ca7.png";